import React, { memo } from 'react';
import { Button } from 'antd';
import { ControlOutlined } from '@ant-design/icons';
import createStore from 'polotno/model/store';
import { ZoomButtons } from 'polotno/toolbar/zoom-buttons';
import { useGlobalContext } from '@src/context/globalContext';
import './WorkspaceControls.less';

interface WorkspaceControlsProps {
  store: ReturnType<typeof createStore>;
  showControls: boolean;
  onToggleControls: () => void;
}

export const WorkspaceControls = memo(({ store, showControls, onToggleControls }: WorkspaceControlsProps) => {
  const { ActiveView: [activeView] } = useGlobalContext();
  
  return (
    <div className="workspace-controls">
      {/* <Button
        type="text"
        icon={<ControlOutlined style={{ fontSize: '30px' }} />}
        onClick={onToggleControls}
        style={{
          position: 'absolute',
          top: '0px',
          left: '0px',
          zIndex: 1000,
          color: 'var(--color-primary-600)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'white',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          transition: 'all 0.3s ease',
          width: '40px',
          height: '40px',
          padding: '8px'
        }}
      /> */}

      {activeView === 'canvas' && (
        <div className="zoom-controls">
          <ZoomButtons store={store} />
        </div>
      )}
    </div>
  );
});

WorkspaceControls.displayName = 'WorkspaceControls'; 